class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    // Respaldo para cerrar el carrito incluso tras reemplazos dinámicos del contenido.
    this.addEventListener('click',(event)=>{
      const target=event.target instanceof Element?event.target:event.target?.parentElement;
      if(target?.closest('.drawer__close, [data-arome-cart-close]')){
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }
    });

    // Todos los accesos al carrito abren el mismo panel, sin navegar a /cart.
    document.addEventListener('click',(event)=>{
      const target=event.target instanceof Element?event.target:event.target?.parentElement;
      const link=target?.closest('a[href],button[data-cart-open]');
      if(!link||!this.isConnected||event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const href=link.getAttribute('href')||'';
      let isCartPath=false;
      if(href){
        try{
          const destination=new URL(href,window.location.href);
          isCartPath=destination.origin===window.location.origin && destination.pathname.replace(/\/$/,'')==='/cart';
        }catch(_){}
      }
      const isCartLink=isCartPath||link.matches('button[data-cart-open], #cart-icon-bubble, .ar-dani-exact__cart, .arome-inner-floating-nav__cart');
      if(!isCartLink)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.open(link);
    },true);

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.toggleOverlappingBars(true);
    this.startCartFlash();
  }

  stopCartFlash() {
    if (this.arFlashTimers) this.arFlashTimers.forEach(clearTimeout);
    this.arFlashTimers = [];
    if (this.arFlashClock) { clearInterval(this.arFlashClock); this.arFlashClock = null; }
    if (this.arFlashAnimation) { this.arFlashAnimation.cancel(); this.arFlashAnimation = null; }
    const message = this.querySelector('.ar-cart-flash__message');
    if (message) { message.classList.remove('ar-flash-enter'); message.style.removeProperty('opacity'); message.style.removeProperty('left'); }
  }

  startCartFlash() {
    this.stopCartFlash();
    const message = this.querySelector('.ar-cart-flash__message');
    const clock = this.querySelector('.ar-cart-flash__countdown');
    if (clock) {
      const updateClock = () => {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Cancun', hour: '2-digit', minute: '2-digit',
          second: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        const t = Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
        const remain = 86400 - (t.hour * 3600 + t.minute * 60 + t.second);
        clock.textContent = [Math.floor(remain / 3600), Math.floor(remain % 3600 / 60), remain % 60].map(v => String(v).padStart(2, '0')).join(':');
      };
      updateClock();
      this.arFlashClock = setInterval(updateClock, 1000);
    }
    if (!message) return;
    const phrases = ['🔥 ¡Tienes una promoción activa por tiempo limitado!', '🛍️ ¡Tu descuento ya está aplicado! Finaliza tu compra.', '✨ ¡Aprovecha las promociones por tiempo limitado!'];
    let index = 0;
    const show = () => {
      if (!this.classList.contains('active')) return;
      const track = message.parentElement;
      message.textContent = phrases[index];
      index = (index + 1) % phrases.length;
      message.style.opacity = '1';
      message.style.left = '0';
      const startX = track.clientWidth;
      const endX = -message.scrollWidth;
      const duration = 9000;
      if (this.arFlashAnimation) this.arFlashAnimation.cancel();
      this.arFlashAnimation = message.animate([
        { transform: 'translate3d(' + startX + 'px,-50%,0)', opacity: 1 },
        { transform: 'translate3d(' + endX + 'px,-50%,0)', opacity: 1 }
      ], { duration, easing: 'linear', fill: 'forwards' });
      this.arFlashAnimation.onfinish = () => {
        message.style.opacity = '0';
        this.arFlashTimers.push(setTimeout(show, 550));
      };
    };
    this.arFlashTimers.push(setTimeout(show, 40));
  }

  toggleOverlappingBars(hide) {
    const selectors = ['#arome-inner-floating-nav', '.ar-dani-exact__header', '.ar-october-audience', '.ar-buen-fin-bar', '.ar-mobile-bottom-nav', '.ar-dani-exact__eyebrow', '.ar-dani-exact__brand', '.ar-dani-exact__brand-text', '.ar-dani-exact__logo'];
    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (hide) el.style.setProperty('visibility', 'hidden', 'important');
        else el.style.removeProperty('visibility');
      });
    });
    document.body.classList.toggle('ar-cart-overlay-open', hide);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.toggleOverlappingBars(false);
    this.stopCartFlash();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, options = {}) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      const sectionHTML = parsedState?.sections?.[section.id];
      if (!sectionElement || !sectionHTML) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    // Algunas compras rápidas de portada refrescan el drawer en silencio
    // para que al abrirlo después ya muestre artículos, descuentos y totales reales.
    if (options.open === false) return;

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
